import { PostWithUser } from "../../types/index.type";
import { getVibeIcon } from "../../utils/posts-style";

type ReactionsProps = {
  vibeCounts: PostWithUser["post"]["vibeCounts"];
};

export const Reactions = ({ vibeCounts }: ReactionsProps) => {
  const getTotalVibes = (vibeCounts: Record<string, number>) => {
    return Object.values(vibeCounts).reduce((sum, count) => sum + count, 0);
  };

  return (
    <div className="flex items-center justify-between pt-4 border-t border-gray-100">
      <div className="flex items-center gap-1">
        <span className="text-sm font-medium text-gray-600">{getTotalVibes(vibeCounts)} reactions</span>
      </div>

      <div className="flex items-center gap-1">
        {Object.entries(vibeCounts).map(
          ([type, count]) =>
            count > 0 && (
              <div
                key={type}
                className="group flex items-center gap-1.5 px-2 py-1 bg-gray-50 hover:bg-gray-100 rounded-full transition-colors"
              >
                {getVibeIcon(type)}
                <span className="text-sm font-medium text-gray-700">{count}</span>
              </div>
            )
        )}
      </div>
    </div>
  );
};
